import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import React, { useEffect, useRef, useState } from "react";
import { SuccessTemplate } from "./common/ToastMessage/Template";

export const CourseDiscountItem = ({ discountItem }) => {
  const copiedToast = useRef(null);

  const [remainingTime, setRemainingTime] = useState(discountItem?.remainingTime);

  const showCopiedToast = () => {
    copiedToast.current.show({ 
      severity: "success", 
      summary: "Copied", 
      detail: discountItem?.code,
      life: 3000, 
      content: (props) => SuccessTemplate(props)
    });
  };

  useEffect(() => {
    const saleDuration = setInterval(() => {
      setRemainingTime((prev) => prev - 1);
    }, 1000);

    return () => {
      clearInterval(saleDuration);
    };
  }, [discountItem]);

  return (
    <div className="course-discount-item p-3">
      <Toast ref={copiedToast} position="bottom-right" className="keduall-toast"/>
      <h2 className="font-size-30 line-height-36 font-weight-600 m-0">{discountItem?.title}</h2>
      <h4 className="line-height-20 font-size-14 font-weight-600 mt-2">{discountItem?.subtitle}</h4>
      <div className="flex justify-content-between align-items-center">
        <p className="font-weight-500 font-size-14 line-height-20 primary-color">
          Mã: <span>{discountItem?.code}</span>
        </p>
        <Button onClick={showCopiedToast} className="outlined-btn" label="Sao chép" icon="pi pi-copy" iconPos="right" />
      </div>
      <div className="flex justify-content-between align-items-center bg-orange-color height-30 white-color mt-1">
        <div className="flex">
          <svg style={{ margin: "0 0.6rem" }} width="9" height="17" viewBox="0 0 9 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M0.833984 1.50008V9.00008C0.833984 9.45841 1.20898 9.83341 1.66732 9.83341H3.33398V15.7917C3.33398 16.2167 3.89232 16.3667 4.10898 16.0001L8.43398 8.58341C8.75899 8.02508 8.35898 7.33341 7.71732 7.33341H5.83398L7.90898 1.79175C8.11732 1.25008 7.71732 0.666748 7.13398 0.666748H1.66732C1.20898 0.666748 0.833984 1.04175 0.833984 1.50008Z"
              fill="white"
            />
          </svg>
          <span className="font-size-12 line-height-16 font-weight-600">Flash sale</span>
        </div>
        <div className="font-size-12 line-height-16 font-weight-600 mr-1">
          <span>Kết thúc trong</span>
          <span>&nbsp;</span>
          <span className="font-weight-700">{Math.floor(remainingTime / 3600)}</span>
          <span>&nbsp;</span>
          <span>h</span>
          <span>&nbsp;</span>
          <span className="font-weight-700">{Math.floor((remainingTime % 3600) / 60)}</span>
          <span>&nbsp;</span>
          <span>m</span>
          <span>&nbsp;</span>
          <span className="font-weight-700">{remainingTime % 60}</span>
          <span>&nbsp;</span>
          <span>s</span>
        </div>
      </div>
      <div className="word-break-overflow gray-color font-weight-400 font-size-12 line-height-16 flex flex-column mt-3">
        {discountItem?.description?.map((item) => (
          <div className="flex align-items-center">
            <i className="pi pi-circle-fill mx-2 font-size-5"></i>
            <p className="m-0">{item}</p>
          </div>
        ))}
      </div>
    </div>
  );
};
